import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// The board notices every view of MLS® listings carries (PropTx MLS® Rules, VOW display;
// TRREB VOW Datafeed Agreement 6.3), and CREA's trademark lines for the footer. The text
// lives in public/content/mls_notices.json, which the server-rendered pages read too.
const NOTICES_URL = '/content/mls_notices.json';

let noticesPromise = null;

/** The notices file, fetched once per page load ({} if it cannot be read). */
export function loadMlsNotices() {
  if (!noticesPromise) {
    noticesPromise = fetch(NOTICES_URL)
      .then((res) => (res.ok ? res.json() : {}))
      .catch(() => ({}));
  }
  return noticesPromise;
}

// The search and listing pages have no site footer, so the listing block carries
// CREA's trademark lines too (the cards and pages print "MLS®").
const FIELDS = {
  listing: ['listing_notices', 'trademark_notices'],
  short: ['short_notice'],
  trademark: ['trademark_notices'],
};

const asLines = (value) => {
  if (typeof value === 'string') return value ? [value] : [];
  return Array.isArray(value) ? value : [];
};

/**
 * kind="listing" (default): the data notices and trademark lines, under any view of MLS® listings.
 * kind="short": the same points in one line, where the full block has no room (the map view).
 * kind="trademark": CREA's MLS® and REALTOR® trademark lines alone (the site footer).
 */
const MlsDataNotice = ({ kind = 'listing', sx, typographySx }) => {
  const [lines, setLines] = useState([]);

  useEffect(() => {
    let active = true;
    loadMlsNotices().then((content) => {
      if (active) setLines(FIELDS[kind].flatMap((field) => asLines(content?.[field])));
    });
    return () => {
      active = false;
    };
  }, [kind]);

  if (!lines.length) return null;

  return (
    <Box
      component={kind === 'trademark' ? 'div' : 'aside'}
      aria-label={kind === 'trademark' ? undefined : 'Listing data notices'}
      sx={sx}
    >
      {lines.map((text) => (
        <Typography
          key={text}
          variant="caption"
          component="p"
          color="text.secondary"
          sx={{ mb: 0.1, fontSize: { xs: '0.66rem', sm: '0.70rem' }, ...typographySx }}
        >
          {text}
        </Typography>
      ))}
    </Box>
  );
};

export default MlsDataNotice;
